import { PermissionsGroup } from "@robe/core-types/group";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

export interface GetGroupResponse {
  id: string;
  name: string;
  permissions: PermissionsGroup[];
}

/** This may still return separate write boolean, this boolean is considered deprecated, should not be used and will be removed in future */
export const getGroup = (name: string, core: XcoreCore): BaseApiRequest<GetGroupResponse> =>
  core.fetch("/api/groups/" + name).then((res) => res.json());
